/*
  FILE: italiansecret-delivery-instructions.js
  Purpose: Persists courier-facing delivery instructions to Shopify cart
  attributes before checkout.
*/

(function () {
  var DEFAULT_ATTRIBUTE_KEY = "delivery_instructions";
  var SYNCED_STATUS_TIMEOUT = 1800;
  var MAX_INSTRUCTION_LENGTH = 90;

  function limitField(field) {
    field.maxLength = MAX_INSTRUCTION_LENGTH;
    field.value = (field.value || "").slice(0, MAX_INSTRUCTION_LENGTH);
  }

  function debounce(fn, wait) {
    var timer = null;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  function getFields() {
    return Array.prototype.slice.call(
      document.querySelectorAll("[data-is-delivery-instructions-input]")
    );
  }

  function getAttributeKey(field) {
    var wrapper = field && field.closest("italiansecret-delivery-instructions");
    return (
      (wrapper && wrapper.getAttribute("data-attribute-key")) ||
      DEFAULT_ATTRIBUTE_KEY
    );
  }

  function getPrimaryField() {
    var focused = document.activeElement;
    if (focused && focused.matches && focused.matches("[data-is-delivery-instructions-input]")) {
      return focused;
    }

    var fields = getFields();
    return fields.length ? fields[0] : null;
  }

  function postCartAttributes(attributeKey, value) {
    var attributes = {};
    attributes[attributeKey || DEFAULT_ATTRIBUTE_KEY] = value || "";

    return fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ attributes: attributes }),
    }).then(function (response) {
      if (!response.ok) throw new Error("Cart update failed");
      return response.json().catch(function () {
        return {};
      });
    });
  }

  function mirrorValue(sourceField) {
    var key = getAttributeKey(sourceField);
    getFields().forEach(function (field) {
      if (field === sourceField || getAttributeKey(field) !== key) return;
      field.value = sourceField.value;
    });
  }

  function setStatus(wrapper, message) {
    var status = wrapper && wrapper.querySelector("[data-is-delivery-instructions-status]");
    if (!status) return;

    status.textContent = message || "";
    status.classList.toggle("is-visible", !!message);

    if (message) {
      clearTimeout(status._italianSecretTimer);
      status._italianSecretTimer = setTimeout(function () {
        status.textContent = "";
        status.classList.remove("is-visible");
      }, SYNCED_STATUS_TIMEOUT);
    }
  }

  function syncField(field, showStatus) {
    if (!field) return Promise.resolve();

    limitField(field);
    mirrorValue(field);

    var wrapper = field.closest("italiansecret-delivery-instructions");
    var key = getAttributeKey(field);
    var value = field.value || "";

    return postCartAttributes(key, value)
      .then(function () {
        field.dataset.isSyncedValue = value;
        if (showStatus) setStatus(wrapper, "Saved");
      })
      .catch(function () {
        if (showStatus) setStatus(wrapper, "Could not save. Please try again.");
      });
  }

  function syncAll() {
    var field = getPrimaryField();
    return syncField(field, false);
  }

  window.ItalianSecretDeliveryInstructions = {
    syncAll: syncAll,
  };

  if (!customElements.get("italiansecret-delivery-instructions")) {
    customElements.define(
      "italiansecret-delivery-instructions",
      class ItalianSecretDeliveryInstructions extends HTMLElement {
        connectedCallback() {
          var field = this.querySelector("[data-is-delivery-instructions-input]");
          if (!field || field.dataset.deliveryInstructionsReady === "true") return;

          field.dataset.deliveryInstructionsReady = "true";
          field.dataset.isSyncedValue = field.value || "";
          limitField(field);

          var persist = debounce(function () {
            if (field.dataset.isSyncedValue === field.value) return;
            syncField(field, true);
          }, 300);

          field.addEventListener("input", function () {
            limitField(field);
            mirrorValue(field);
            persist();
          });

          field.addEventListener("change", function () {
            mirrorValue(field);
            syncField(field, true);
          });

          field.addEventListener("blur", function () {
            mirrorValue(field);
            if (field.dataset.isSyncedValue !== field.value) syncField(field, false);
          });
        }
      }
    );
  }
})();
